import { csx } from '@vtex/admin-ui'
import type { HTMLAttributes, ReactNode } from 'react'
import React from 'react'

type ProductSpecificationsContentProps = {
  children: ReactNode
} & HTMLAttributes<HTMLDivElement>

export const ProductSpecificationsContent = ({
  children,
  ...props
}: ProductSpecificationsContentProps) => {
  return (
    <div
      {...props}
      className={csx({
        paddingY: '$space-3',
        ':not(:last-child)': {
          borderBottom: '$neutral',
        },
      })}
    >
      {children}
    </div>
  )
}
